/**
 * Static policy copy shared across the booking flow — the Step 5 summary policy
 * accordions and the step-3 valet warning modal. Defined once here so the
 * strings are not duplicated.
 */

export const ARRIVAL_WINDOW_POLICY =
  'The Pro will do their best to arrive at the beginning of the arrival window but sometimes there are challenges with traffic, parking, and other delays en route. For this reason we provide arrival windows when the Pro will arrive to begin the appointment.'

export const DEFAULT_VALET_POLICY =
  'Glamsquad Beauty Professionals will do their best to find free parking. If they are unable to, they reserve the right to charge you for valet parking. Please see our FAQs for details.'
